export default __webpack_public_path__ + "static/media/icon-pinterest.13344497.svg";